import { Button } from "primereact/button"
import { formatDate, getDate } from "medere-ui-framework"
import { BudgetDTO } from "../../dto/budget/BudgetDTO"
import { EBudgetGridOptions, EBudgetGridOptionsValues } from "../../enums/EBudgetGridOptions"
import BillItemsReadOnly from "./billHospitalization/BillItemsReadOnly"
import BillSummary from "./billHospitalization/BillSummary"
import NvTooltips from "../../components/novarium/NvTooltips"
import './billHospitalization/novariumBill.scss'

interface BillHospitalizationPreviewProps {
    setSelectedAction: (action: number) => void;
    selectedBudget: BudgetDTO;
    setSelectedBudget: (selectedBudget: BudgetDTO) => void;
    setOpenPrintBudgetModal: (value: boolean) => void;
}

/** Estado "Prefacturada": ya tiene órdenes generadas y no se edita. */
const PREINVOICED_STATE = 6;

/** Vista previa de una facturación sanatorial (vista de detalle del design system: datos como texto). */
export default function BillHospitalizationPreview({ setSelectedAction, selectedBudget, setOpenPrintBudgetModal }: BillHospitalizationPreviewProps) {
    const budget = selectedBudget;
    const patientName = budget.patientdesc || budget.addressee || '';
    const canEdit = budget.budgetstate !== PREINVOICED_STATE;

    const data: { label: string; value: string | number | null | undefined; size: 's' | 'm' }[] = [
        { label: 'N.° de facturación', value: budget.budget, size: 's' },
        { label: 'Fecha de prefacturación', value: formatDate(getDate(budget.date)), size: 's' },
        { label: 'Estado', value: budget.budgetstatedescription, size: 's' },
    ];
    const patientData: { label: string; value: string | number | null | undefined; size: 's' | 'm' }[] = [
        { label: 'Paciente', value: patientName, size: 'm' },
        { label: 'DNI', value: budget.dni, size: 's' },
        { label: 'N.° de afiliado', value: budget.affiliatenumber, size: 's' },
        { label: 'Obra social', value: budget.agreementdesc, size: 'm' },
        { label: 'Plan', value: budget.agreementplandesc, size: 'm' },
    ];

    const renderData = (list: typeof data) => (
        <div className="nv-form-row">
            {list.map(d => (
                <div key={d.label} className={`nv-ro ${d.size === 's' ? 'nv-w-s' : 'nv-w-m'}`}>
                    <span className="nv-ro-label">{d.label}</span>
                    <span className="nv-ro-value">{d.value === null || d.value === undefined || d.value === '' ? '—' : d.value}</span>
                </div>
            ))}
        </div>
    );

    return (
        <div className="nv-scope nv-page">
            <NvTooltips />

            <header className="nv-page-head">
                <div className="nv-head-row">
                    <Button type="button" link icon="pi pi-angle-double-left" label="Volver" onClick={() => setSelectedAction(-1)} />
                    <div className="nv-row-8">
                        <Button type="button" className="buttonMain2" outlined icon="pi pi-download" label="Descargar PDF" onClick={() => setOpenPrintBudgetModal(true)} />
                        {canEdit && (
                            <Button type="button" className="buttonMain2" outlined icon="pi pi-pencil" label="Editar" onClick={() => setSelectedAction(EBudgetGridOptionsValues[EBudgetGridOptions.EDIT])} />
                        )}
                    </div>
                </div>
                <h1 className="nv-h1">Facturación sanatorial</h1>
                {patientName && <span className="nv-subtitle">{patientName}</span>}
            </header>

            <section className="nv-section" aria-labelledby="nv-preview-data">
                <h2 className="nv-section-title" id="nv-preview-data">Datos de la facturación</h2>
                {renderData(data)}
            </section>

            <section className="nv-section" aria-labelledby="nv-preview-patient">
                <h2 className="nv-section-title" id="nv-preview-patient">Paciente</h2>
                {renderData(patientData)}
            </section>

            <BillItemsReadOnly budget={budget} />

            <BillSummary budget={budget} />
        </div>
    );
}
